import { render, staticRenderFns } from "./NsrConfigDialog.vue?vue&type=template&id=65f6ace2"
import script from "./NsrConfigDialog.vue?vue&type=script&lang=js"
export * from "./NsrConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./NsrConfigDialog.vue?vue&type=style&index=0&id=65f6ace2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports